import React from 'react';
import PropTypes from 'prop-types';
import { mergeStyles } from '@fluentui/react';

const couponDaysLeftStyles = mergeStyles({
  fontWeight: 'bold',
});

export const DaysRemaining = ({ i18n, diffDays }) =>
  (
    <span className={couponDaysLeftStyles}>
      {diffDays === 1
      ? i18n.getString('RemindLater_Description_Expiration_OneDay')
      : i18n.getString('RemindLater_Description_Expiration', { diffDays })}
    </span>
  );

DaysRemaining.propTypes = {
  diffDays: PropTypes.number.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
};
